import { StyleSheet } from '@react-pdf/renderer'

const pageHorizontalPadding = 30

const styles = StyleSheet.create({
  pageHeaderContainer: {
    height: 50,
    paddingHorizontal: pageHorizontalPadding,
    paddingVertical: 10,
    backgroundColor: '#F8F9FA',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  pageHeaderImage: {
    width: 30,
    height: 30,
    objectFit: 'scale-down',
    marginRight: 10
  },
  pageHeaderText: {
    color: '#6d39d9',
    fontSize: 11,
    fontStyle: 'normal',
    fontWeight: 800,
    letterSpacing: 2,
    textTransform: 'uppercase'
  },
  pageBody: {
    paddingHorizontal: pageHorizontalPadding,
    paddingVertical: 10
  },
  descriptionText: {
    color: '#6c757d',
    fontSize: 8
  },
  section: {
    marginVertical: 5,
    border: '1px solid #E7EAF3',
    borderRadius: 3.75,
    padding: 10
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  rowItem: {
    flex: 1
  },
  sectionHeader: {
    fontSize: 8,
    fontWeight: 700,
    color: '#343A40',
    marginBottom: 10
  },
  quoteDetailValue: {
    color: '#212529',
    fontSize: 10
  },
  halfSectionValue: {
    color: '#212529',
    fontSize: 7,
    marginLeft: 5
  },
  tableRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 3
  },
  tableCellValue: {
    color: '#212529',
    fontSize: 7
  },
  detailsSectionHeader: {
    color: '#6D39D9',
    fontSize: 11,
    marginBottom: 5
  },
  detailsSectionContent: {
    fontSize: 10
  }
})

export default styles
